import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueBarcode from 'vue-barcode'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {
	Validator
} from 'vee-validate'
// import Printd from 'printd'
export default {
	name: 'po',
	components: {
		Paginate,
		VueElementLoading,
		'barcode': VueBarcode
	},

	data: function () {
		return {
			shipmentDetailsCount: '',
			isLoading: false,
			loginwarehouseid: 0,
			loginClientUserId: 0,
			poid: '',
			pono: '',
			urlclientid: '',
			urlwarehouseid: '',
			listOrderMasterdata: [],
			orderDetailsCount: 0,
			listOrderDetailsData: [],
			totalitems: '',
			totalorderqty: 0,
			totalamount: 0,
			shipMasterData: [],
			listShippingDetailsData: [],
			shipcount: 0,
			pagenoship: 0,
			pagenoorder: 0,
			// initialize form field
		}
	}, // end data

	created: function () {

	},
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},
	computed: {
		discount: function () {
			return this.listOrderDetailsData.reduce(function (discount, item) {
				return discount + item.discount;
			}, 0);
		},

	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginwarehouseid = userdetail.warehouseid;
		this.loginClientUserId = userdetail.clientid;
		this.getorderDetails();
		this.getshippingData();
		this.getOrderItemDetails();
		this.pagenoship = 0
		this.pagenoorder = 0;
	},

	methods: {
		getScore(val) {
			if (!val) {
				return 0.00
			}
			return val.toFixed(2);
		},
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},

		toUpper(str) {
			if (str !== null && str !== undefined) {
				return str.charAt(0).toUpperCase() + str.slice(1);
			} else {
				return '--'
			}

		},
		getorderDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pono = this.$route.params.poid
			this.urlclientid = this.loginClientUserId ? this.loginClientUserId : this.$route.query.clientid
			this.urlwarehouseid = this.loginwarehouseid ? this.loginwarehouseid : this.$route.query.warehouseid
			this.poid = this.pono;
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "orderDetails"
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSingleOrderDetailsUpdatedForTab',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listOrderMasterdata = result.data.data.orderMaster[0];
					this.orderDetailsCount = this.listOrderMasterdata.length;
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},
		getshippingData() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pono = this.$route.params.poid
			this.urlclientid = this.loginClientUserId ? this.loginClientUserId : this.$route.query.clientid
			this.urlwarehouseid = this.loginwarehouseid ? this.loginwarehouseid : this.$route.query.warehouseid
			this.poid = this.pono;
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "ShippingDetails"
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSingleOrderDetailsUpdatedForTab',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.shipMasterData = result.data.data.shipping_data[0];
					this.shipcount = result.data.data.shipCount
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},
		getOrderItemDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pono = this.$route.params.poid
			this.urlclientid = this.loginClientUserId ? this.loginClientUserId : this.$route.query.clientid
			this.urlwarehouseid = this.loginwarehouseid ? this.loginwarehouseid : this.$route.query.warehouseid
			this.poid = this.pono;
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "OrderItemDetails"
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSingleOrderDetailsUpdatedForTab',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listOrderDetailsData = result.data.data.orderDetails;
					this.totalitems = this.listOrderDetailsData.length;
					for (var i = 0; i < this.totalitems; i++) {
						this.totalorderqty += Number(this.listOrderDetailsData[i].totalqty)
						this.totalamount += ((this.listOrderDetailsData[i].totalqty * this.listOrderDetailsData[i].mrp) - this.listOrderDetailsData[i].discount)
					}
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/orderdetailstab/orderdetails/orderdetails.component.js